import { useOpenWindow } from '@krp/client-runtime'
import { DeliveryIndicator, OWN_WINDOWS, useDeliveryMonitor, type AgentSession, type OwnDispatch } from '@krp/resource-own-ui'

/**
 * Полоса «учтено на сервере» под экраном продажи (RP-OWN9). Только диагностика: читает состояние выгрузки агента редко, уступает
 * денежной операции и ни на что в продаже не влияет. Сессию агента даёт окно продажи, второго поиска агента нет.
 */
export function OwnDeliveryStrip({ agent, resourceId, dispatch }: { agent: AgentSession; resourceId: string; dispatch: OwnDispatch }) {
  const openWindow = useOpenWindow()
  const { view, refresh } = useDeliveryMonitor(agent, { dispatch })
  return <DeliveryIndicator view={view} compact onRefresh={refresh} onDetails={() => openWindow(OWN_WINDOWS.delivery, { rid: resourceId })} />
}
